import React, { useMemo, useState } from "react";
import * as Icons from "lucide-react";
import { categories } from "../mock/menuData";
import MenuItemCard from "../components/MenuItemCard";
import ItemCustomizeModal from "../components/ItemCustomizeModal";

const Menu = () => {
  const [active, setActive] = useState(categories[0].id);
  const [selected, setSelected] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const current = useMemo(() => categories.find((c) => c.id === active), [active]);

  const openItem = (item) => {
    setSelected(item);
    setModalOpen(true);
  };

  return (
    <div className="brick-bg min-h-screen pt-24 pb-20">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-8">
          <span className="font-script text-4xl text-pink">La Carte</span>
          <h1 className="font-display text-4xl md:text-5xl uppercase text-white mt-1">Commandez en ligne</h1>
          <p className="text-white/50 mt-2">Personnalisez viandes, sauces & boissons — ajout au panier instantané.</p>
        </div>

        {/* category tabs */}
        <div className="sticky top-16 z-30 -mx-4 px-4 py-3 bg-[#0c0c0c]/90 backdrop-blur border-y border-white/10 mb-8">
          <div className="flex gap-2 overflow-x-auto no-scrollbar pb-1">
            {categories.map((c) => {
              const Ic = Icons[c.icon] || Icons.Utensils;
              const on = active === c.id;
              return (
                <button
                  key={c.id}
                  onClick={() => setActive(c.id)}
                  className={`shrink-0 flex items-center gap-2 px-4 py-2 rounded-full font-display uppercase text-sm transition-all ${
                    on ? "bg-pink text-white" : "bg-white/5 text-white/70 hover:bg-white/10"
                  }`}
                >
                  <Ic size={16} /> {c.label}
                </button>
              );
            })}
          </div>
        </div>

        <div className="flex items-center gap-3 mb-6">
          <h2 className="font-display text-2xl md:text-3xl uppercase text-gold">{current.label}</h2>
          {current.note && <span className="text-xs text-white/50 border border-white/20 rounded-full px-3 py-1">{current.note}</span>}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {current.items.map((item) => (
            <MenuItemCard key={item.id} item={item} onAdd={openItem} />
          ))}
        </div>
      </div>

      <ItemCustomizeModal item={selected} open={modalOpen} onClose={() => setModalOpen(false)} />
    </div>
  );
};

export default Menu;
